import { trim, chain, startsWith } from "lodash"
import { ValidationError, TechnicalError, ForbiddenError, NotJsonError, UnauthorizedError, NotFoundError, TooManyRequestsError } from "./errors"

function getCustomResponseHeaders(response) {
  return chain(response.headers)
    .thru(headers => Object.fromEntries(headers))
    .pickBy((_, key) => startsWith(key, "x-omegapoint-"))
    .value()
}

export function processResponse(response) {
  const contentType = response.headers.get("content-type")
  const isJsonResponse = contentType && contentType.indexOf("application/json") !== -1
  const isCsvResponse = contentType && contentType.indexOf("text/csv") !== -1

  if (response.status === 201) {
    return response.headers.get("location") ?? undefined
  } else if ([202, 204].includes(response.status)) {
    return undefined
  } else if (response.status === 404) {
    return response.text().then(body => {
      throw new NotFoundError(body, getCustomResponseHeaders(response))
    })
  } else if (response.status === 401) {
    throw new UnauthorizedError()
  } else if (response.status === 403) {
    throw new ForbiddenError()
  } else if (isCsvResponse) {
    const filename = trim(response.headers.get("Content-Disposition"), 'attachment; filename=""')
    return response.blob().then(blob => URL.createObjectURL(blob)).then(url => {
      const a = document.createElement("a")
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      URL.revokeObjectURL(url)
      a.remove()
    })
  } else if (response.status === 429) {
    const retryAfter = response.headers.get("Retry-After")
    throw new TooManyRequestsError(retryAfter)
  } else if (isJsonResponse) {
    return response.json().then(body => {
      if (response.status === 400) {
        if (body.errors) {
          throw new ValidationError(body.errors, getCustomResponseHeaders(response))
        } else {
          throw new TechnicalError(body)
        }
      } else if (response.status > 400) {
        throw new TechnicalError(body.error || body)
      } else {
        return body
      }
    })
  // Internal server error
  } else if (response.status === 500) {
    return response.text().then(body => {
      throw new TechnicalError(body)
    })
  } else {
    return response.text().then(body => {
      if (!body) {
        return null
      } else {
        throw new NotJsonError(response)
      }
    })
  }
}
